import { Box, Button, InputBase, Typography, Modal } from "@mui/material";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateBatchHistory, updateInventoryDetail, updateinventoryDetailsEdit, updateInventoryDetailsModal, updatesearchBatchProduct, updateSelectedBatchNo } from "../../Redux/inventory";
import CustomAxios from "../../utils/CustomAxios";
import { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { BatchViewTable } from "../../sub_components/batch_view_table";
import SearchIcon from '@mui/icons-material/Search';
import { OrderDetailsModal, useGetBatchHistory } from "../globalFunctions";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import * as XLSX from "xlsx";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DownloadIcon from '@mui/icons-material/Download';
import { LoadingButton } from "@mui/lab";

export function BatchHistory() {
    const toast = useRef(null)
    const user_id = useSelector( state => state.user.id)
    const batchHistory = useSelector(state => state.inventory.batchHistory)
    const selectedBatchNo = useSelector(state => state.inventory.selectedBatchNo)
    const selectedHub = useSelector(state => state.user.selected_hub);
    const [batchNo,setBatchNo] = useState()
    const dispatch = useDispatch()
    const getBatchHistory = useGetBatchHistory()
    const [bulkOpen, setBulkOpen] = useState(false);
    const [bulkUploading, setBulkUploading] = useState(false);
    const [bulkErrors, setBulkErrors] = useState([]);
    const bulkInputRef = useRef(null);

        useEffect(() => {
            getBatchHistory()
        }, [])

 const handleOpen = () => {
        dispatch(updateInventoryDetail({
            batch:[{
                product_id: "",
                available_units: "",
                units: "",
                total_units: "",
                expired_on: null,
                expire_alert: null,
                bogo_enabled:false,
                quantity: "",
            }
            ],
            place: "",
            supervisor_ids: [
                0
            ],
            details_id: '',
            purchased_on: null,
            supplier: '',
            invoice: '',
            batch_no:'',
        }));
        dispatch(updateinventoryDetailsEdit(false));
        dispatch(updateInventoryDetailsModal(true))
    };
        console.log(selectedBatchNo)

              const confirmDelete = (item) => {
                console.log(item)
                confirmDialog({
                  message: (
                    <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
                      <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                        Do you want to delete this Batch
                      </Typography>
                    </Box>
                  ),
                  header: "Delete Confirmation",
                  defaultFocus: 'reject',
                  acceptClassName: 'p-button-danger',
                  accept: () => accept(item),
                });
              };
            
              const accept = async (batch) => {
                try {
                  await CustomAxios.delete(`inventory/details/delete/${batch.id}/`,{data:{admin_id:user_id,batch_delete:true}})
                  .then(() => {
                    getBatchHistory()
                    dispatch(updateSelectedBatchNo({}))
                    toast.current.show({
                          severity: "success",
                          summary: "Success",
                          detail: "Batch details deleted successfully",
                          life: 3000,
                        });
                  })
                        
                } catch (err) {
                  console.error("Error deleting delivery details", err);
                }
              };
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%", padding: "30px" }}>
            <Toast ref={toast} />
            {/* <ConfirmDialog /> */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Product Management</Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>Inventory / Batch History</Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <Box sx={{ position: "relative",display:"flex",gap:"20px" }}>
                    <Box sx={{  display: "flex", flexDirection: "column", gap: "10px" }}>
                        <Dropdown onChange={(e)=>dispatch(updateSelectedBatchNo(e.target.value))} value={selectedBatchNo} options={batchHistory} optionLabel="batch_number" style={{ zIndex: "1000", height: "32px", width: "238px" }}
                            placeholder="Select Batch No" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} />
                    </Box>
                    <Box sx={{ position: "relative" }}>
                    <InputBase sx={{ backgroundColor: "white", height: "32px", width: "100%", maxWidth: "360px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} onChange={(e) => dispatch(updatesearchBatchProduct(e.target.value))} placeholder="Search product name" />
                    <SearchIcon sx={{ position: "absolute", left: "12px", top: "5px", width: "20px", height: "20px" }} />
                </Box>
                </Box>
                <Box sx={{ display: "flex", gap: "20px" }}>
                    <Button variant="outlined" disabled={selectedBatchNo?.batch?false:true} sx={{border:"1px solid",borderColor:"secondary.border",textTransform: "none",backgroundColor:"white",opacity:selectedBatchNo?.batch?1:.5}} onClick={()=>confirmDelete(selectedBatchNo)}> <Typography sx={{color:"black",fontSize: {sm:"12px",md:"14px"}, fontWeight: "400", lineHeight: "22px",textAlign:"center",cursor:"pointer"}}> Delete Batch</Typography></Button>
                    <Button variant="contained" sx={{ textTransform: "none",height:"32px" }} onClick={handleOpen}> Add Items</Button>
                    <Button variant="outlined" startIcon={<UploadFileIcon />} sx={{ textTransform: "none",height:"32px" }} onClick={()=>{setBulkErrors([]); setBulkOpen(true);}}> Bulk Batch Upload</Button>
                </Box>
            </Box>
            <BatchViewTable/>
            <OrderDetailsModal/>
            <input
                type="file"
                accept=".xlsx"
                ref={bulkInputRef}
                onChange={async (e) => {
                    const file = e.target.files?.[0];
                    if (!file) return;
                    setBulkUploading(true);
                    setBulkErrors([]);
                    try {
                        const formData = new FormData();
                        formData.append("file", file);
                        const hubFromRedux = Array.isArray(selectedHub) ? selectedHub[0] : selectedHub;
                        const hubFromLocal = JSON.parse(localStorage.getItem('hub') || '[]')[0];
                        const resolvedHub = hubFromRedux || hubFromLocal;
                        if (resolvedHub) {
                            formData.append("inventory_id", resolvedHub);
                        } else {
                            toast.current.show({ severity: "error", summary: "Missing hub", detail: "No hub selected; cannot upload.", life: 4000 });
                            setBulkUploading(false);
                            return;
                        }
                        const res = await CustomAxios.post("batch/bulk-upload/", formData);
                        const successCount = res?.data?.successCount || 0;
                        const failureCount = res?.data?.failureCount || 0;
                        if (successCount) {
                            toast.current.show({ severity: "success", summary: "Bulk upload", detail: `${successCount} batch items added`, life: 4000 });
                            getBatchHistory();
                        }
                        if (failureCount && res?.data?.errors?.length) {
                            setBulkErrors(res.data.errors);
                            toast.current.show({ severity: "warn", summary: "Partial failures", detail: `${failureCount} rows failed`, life: 5000 });
                        } else {
                            setBulkErrors([]);
                        }
                        setBulkOpen(false);
                    } catch (err) {
                        toast.current.show({ severity: "error", summary: "Bulk upload failed", detail: err?.response?.data?.error || "Upload failed", life: 4000 });
                    } finally {
                        setBulkUploading(false);
                        if (bulkInputRef.current) bulkInputRef.current.value = null;
                    }
                }}
                style={{ display: "none" }}
            />
            <Modal open={bulkOpen} onClose={()=>{setBulkOpen(false); setBulkErrors([]);}}>
                <Box sx={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)', width:480, bgcolor:'white', p:3, display:'flex', flexDirection:'column', gap:2, borderRadius:'8px' }}>
                    <Typography sx={{ fontSize:16, fontWeight:700 }}>Bulk Batch Upload</Typography>
                    <Box sx={{ display:'flex', gap:1 }}>
                        <Button
                            variant="outlined"
                            startIcon={<DownloadIcon />}
                            onClick={()=>{
                                const batchItems = [
                                    ["sku_code","quantity","available_units","units","expired_on","expire_alert","bogo_enabled","purchased_on"],
                                    ["ABC123", 10, 10, "pcs", "2025-12-31", "2025-12-15", false, "2025-12-01"],
                                ];
                                const wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(batchItems), "BatchItems");
                                XLSX.writeFile(wb, "batch_bulk_sample.xlsx");
                            }}
                            sx={{ textTransform:'none' }}
                        >
                            Download Sample
                        </Button>
                        <LoadingButton
                            variant="contained"
                            startIcon={<UploadFileIcon />}
                            loading={bulkUploading}
                            onClick={()=>bulkInputRef.current?.click()}
                            sx={{ textTransform:'none' }}
                        >
                            Upload (.xlsx)
                        </LoadingButton>
                    </Box>
                    {bulkErrors.length > 0 && (
                        <Box sx={{ maxHeight:200, overflowY:'auto', p:1, border:'1px solid', borderColor:'secondary.border', borderRadius:'6px', backgroundColor:'#fafafa' }}>
                            <Typography sx={{ fontWeight:600, mb:1 }}>Failed rows</Typography>
                            {bulkErrors.map((err, idx)=>(
                                <Typography key={idx} sx={{ fontSize:12, color:'error.main' }}>
                                    Row {err?.row}: {err?.message}
                                </Typography>
                            ))}
                        </Box>
                    )}
                </Box>
            </Modal>
        </Box>
    )
}